import type { AnalyticsUser, UserStatus } from './constants';

let currentUser: AnalyticsUser | null = null;

export const setAnalyticsUser = (user: AnalyticsUser | null): void => {
  currentUser = user;
};

export const getAnalyticsUser = (): AnalyticsUser | null => currentUser;

export const getUserStatus = (user: AnalyticsUser | null): UserStatus => {
  if (!user?.id) {
    return 'guest';
  }

  if (user.isEmailVerified) {
    return 'verified';
  }

  return 'registered';
};
